import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 40 40" fill="none">
                  <path d="M8 30L16 20L24 25L32 15L40 20V35H8V30Z" fill="white"/>
                  <circle cx="12" cy="25" r="1.5" fill="#60a5fa"/>
                  <circle cx="18" cy="21" r="1.5" fill="#60a5fa"/>
                  <circle cx="24" cy="23" r="1.5" fill="#60a5fa"/>
                  <circle cx="30" cy="15" r="1.5" fill="#60a5fa"/>
                  <circle cx="36" cy="20" r="1.5" fill="#60a5fa"/>
                </svg>
              </div>
              <span className="ml-2 text-xl font-bold text-gray-900">ProductTrace</span>
            </div>
            <p className="text-gray-600 text-sm max-w-md">
              Analyze products, components, and manufacturing processes. Discover how things are made 
              with AI-powered analysis and supply chain transparency.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Platform
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-gray-900 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-gray-600 hover:text-gray-900 text-sm">
                  Search Products
                </Link>
              </li>
              <li>
                <a 
                  href="/docs" 
                  className="text-gray-600 hover:text-gray-900 text-sm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  API Documentation
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-gray-900 text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-gray-900 text-sm">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:legal@producttrace.io" 
                  className="text-gray-600 hover:text-gray-900 text-sm"
                >
                  Contact Legal
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-6 mb-4 md:mb-0">
              <p className="text-gray-500 text-sm">
                © {currentYear} ProductTrace. All rights reserved.
              </p>
            </div>
            
            <div className="flex items-center space-x-6">
              <a 
                href="mailto:support@producttrace.io" 
                className="text-gray-500 hover:text-gray-700 text-sm"
              >
                Support
              </a>
              <a 
                href="mailto:feedback@producttrace.io" 
                className="text-gray-500 hover:text-gray-700 text-sm"
              >
                Feedback
              </a>
              <span className="text-gray-300">|</span>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-gray-500 text-sm">All systems operational</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 